import { drawImageFile } from "./drawImageFile";
import { hasTransparentPixels, IMAGE_JPEG_QUALITY } from "./imageAttachments";

const toAttachmentFileName = (name: string, extension: string): string => {
  const dotIndex = name.lastIndexOf(".");
  const base = dotIndex > 0 ? name.slice(0, dotIndex) : name;
  return `${base || "image"}.${extension}`;
};

export const resizeImageAttachment = async (file: File): Promise<File> => {
  const { canvas, pixels } = await drawImageFile(file);
  const outputType = hasTransparentPixels(pixels) ? "image/png" : "image/jpeg";
  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, outputType, IMAGE_JPEG_QUALITY));
  if (!blob) {
    throw new Error("Couldn't process the image.");
  }
  return new File([blob], toAttachmentFileName(file.name, outputType === "image/png" ? "png" : "jpg"), {
    type: outputType,
  });
};
